import { render, staticRenderFns } from "./VueFlatPickr.vue?vue&type=template&id=edca9f86"
import script from "./VueFlatPickr.vue?vue&type=script&lang=js"
export * from "./VueFlatPickr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports